import React from 'react';

export function Loader({ label = 'Loading...', className, showLabel = true, minHeight }) {
  return (
    <div
      className={`text-foreground-softest flex flex-col items-center justify-center gap-2 py-10 text-sm ${className || ''}`}
      style={minHeight ? { minHeight } : undefined}
    >
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' className='text-foreground-soft size-5' aria-hidden>
        <path
          fill='currentColor'
          stroke='currentColor'
          d='M12 4a8 8 0 0 1 7.89 6.7 1.53 1.53 0 0 0 1.49 1.3 1.5 1.5 0 0 0 1.48-1.75 11 11 0 0 0-21.72 0A1.5 1.5 0 0 0 2.62 12a1.53 1.53 0 0 0 1.49-1.3A8 8 0 0 1 12 4Z'
        >
          <animateTransform
            attributeName='transform'
            dur='0.6s'
            repeatCount='indefinite'
            type='rotate'
            values='0 12 12;360 12 12'
          />
        </path>
      </svg>
      {showLabel && <span className='text-foreground-soft'>{label}</span>}
    </div>
  );
}

export default Loader;
